module.exports = __webpack_public_path__ + "static/media/item06.dcbd440b.png";